import { StoreColumnExtractor } from './store-column-extractor';

export class MapStoreExtractor implements StoreColumnExtractor {
	private dataPaths = [];
	/**
	 * MapStoreExtractor, ties a specific extractor to a specific key condition. A FALLBACK key must be defined inside the extractor map ass a fallback if the lookup fails,
	 * the keyCondition should return a string which will serve as the key for the lookup.
	 */
	constructor(public readonly stores: string[], private keyCondition: (...storeData: any[]) => string, private extractors: { [key: string]: StoreColumnExtractor }) {
		if (!this.extractors['FALLBACK']) {
			throw new Error('Improper instantiation of MapStoreExtractor: a fallback extractor must be defined in the extractors map with key = FALLBACK');
		}
	}

	public storeConfigDependencies(): any[] {
		return [...this.stores, ...[].concat(...Object.values(this.extractors).map(extractor => extractor.storeConfigDependencies()))];
	}
	public extractor(): (...storeData: any[]) => number | string {
		return (...storeData: any[]) => {
			let key = this.keyCondition(...storeData.slice(0, this.stores.length));
			key = key && this.extractors[key] ? key : 'FALLBACK';
			const dataPath = this.extractors[key].getDataPointPath();
			this.dataPaths.push(dataPath);

			return this.extractors[key].extractor()(...storeData.slice(this.stores.length, this.stores.length + this.extractors[key].storeConfigDependencies().length));
		};
	}

	public getDataPointPath(): string {
		const uniqueValues = this.dataPaths.filter((value, index, array) => array.indexOf(value) === index);

		return uniqueValues.toString();
	}
}
